module.exports = {
	config: {
		staticLookupName: 'profileController'
	},

	methods: {
		setServiceCollectionOptions: function(options){
			store.set({
				session: {
					data: {
						sourceServiceCollectionOptions: options
					}
				}
			});
		}
	},

	hooks: {
		attach: function($element, options){
			console.log(
				'service collection options', (((storage || {}).user || {}).data || {}).serviceCollectionOptions || {},
				'visible Status', (((storage || {}).user || {}).data || {}).visibleStatus || {}
			);
		}
	}
};